import OrganizationSelection from '@auth0/auth0-acul-js/organization-selection';
import { useMemo } from 'react';

import { ContextHooks } from '../hooks';
import { errorManager } from '../hooks';
import { registerScreen } from '../state/instance-store';

import type {
  OrganizationSelectionMembers,
  ContinueWithOrganizationNameOptions,
} from '@auth0/auth0-acul-js/organization-selection';

// Register the singleton instance of OrganizationSelection
const instance = registerScreen<OrganizationSelectionMembers>(OrganizationSelection)!;

// Error wrapper
const { withError } = errorManager;

// Context hooks
const factory = new ContextHooks<OrganizationSelectionMembers>(instance);
export const {
  useUser,
  useTenant,
  useBranding,
  useClient,
  useOrganization,
  usePrompt,
  useScreen,
  useTransaction,
  useUntrustedData,
} = factory;

// Submit functions
export const continueWithOrganizationName = (payload: ContinueWithOrganizationNameOptions) =>
  withError(instance.continueWithOrganizationName(payload));

// Common hooks
export { useCurrentScreen, useErrors, useAuth0Themes, useChangeLanguage } from '../hooks';

// Main instance hook. Returns singleton instance of OrganizationSelection
export const useOrganizationSelection = (): OrganizationSelectionMembers =>
  useMemo(() => instance, []);
